<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>产品别名</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.source_product_code">
                <el-input v-model="source_product_code" placeholder="请输入源产品编码" clearable></el-input>
            </div>
            <div class="main_header_item" v-if="postList.source_entity_account_rid">
                <el-select
                    v-model="source_entity_account_rid"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入账户名称搜索"
                    :remote-method="remoteMethod"
                    :loading="parentLoading"
                    size="mini"
                    clearable
                >
                    <el-option v-for="item in parentOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                </el-select>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addAcount" icon="el-icon-plus" v-if="postList.addBtn">新增产品别名</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(1)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="product_source"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <!-- 上级标签处理 -->
                            <div v-if="item.prop == 'account'">
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row.account && scope.row.account.name}}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editDetails(scope.row)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amend(scope.row.id)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
            <!-- 新增产品别名 -->
            <el-dialog
                :close-on-click-modal="false"
                v-dialogDrag
                :title="titleProduct"
                :visible.sync="dialogFormVisibleProduct"
                width="560px"
                :modal="false"
                :append-to-body="true"
            >
                <el-form
                    :model="rulesDialogFormProduct"
                    :rules="rulesDialogProduct"
                    ref="ruleFormProduct"
                    label-width="140px"
                    class="demo-ruleForm"
                    :before-close="handleClose"
                >
                    <el-form-item label="账户：" prop="source_entity_account_name">
                        <el-select
                            style="width: 100%"
                            v-model="rulesDialogFormProduct.source_entity_account_name"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入账户名称搜索"
                            :remote-method="remoteMethod"
                            :loading="parentLoading"
                            clearable
                            size="mini"
                            @change="valueChange"
                        >
                            <el-option v-for="item in parentOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="源产品编码：" prop="source_product_code">
                        <el-input
                            size="mini"
                            v-model="rulesDialogFormProduct.source_product_code"
                            placeholder="请输入源产品编码"
                            clearable
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="源产品名称：" prop="source_product_name">
                        <el-input
                            size="mini"
                            v-model="rulesDialogFormProduct.source_product_name"
                            placeholder="请输入源产品名称"
                            clearable
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="源产品规格：" prop="source_product_specification">
                        <el-input
                            v-model="rulesDialogFormProduct.source_product_specification"
                            placeholder="请输入源产品规格"
                            clearable
                        ></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancle">取 消</el-button>
                    <el-button type="primary" @click="submitDetailsData('ruleFormProduct')" :loading="btnLoading">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'productFlowComponent',
    data() {
        return {
            draggable: {
                data_name: 'product_source'
            },
            parentOptions: [],
            down_loading: false,
            updateLoading: false,
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            product_rid: '',
            source_product_code: '',
            source_entity_account_rid: '',
            parentOptions: [],
            parentLoading: false,
            btnLoading: false,
            dataType: '',
            titleProduct: '',
            rulesDialogFormProduct: {
                source_entity_account_rid: '', // 账户下拉搜索，必填
                source_entity_account_name: '', // 账户下拉搜索，必填
                source_product_code: '',
                source_product_name: '', // 源产品名称，必填
                source_product_specification: '' // 源产品规格
            },
            rulesDialogProduct: {
                source_entity_account_name: [{ required: true, message: '请输入选择账户', trigger: 'blur' }],
                source_product_name: [{ required: true, message: '请输入源产品名称', trigger: 'blur' }]
            },
            dialogFormVisibleProduct: false
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['productFlow_params']) {
                this.page = paramsList['productFlow_params'].page;
                this.row = paramsList['productFlow_params'].row;
                this.product_rid = paramsList['productFlow_params'].product_rid;
                // this.data_name = paramsList['productFlow_params'].data_name;
                // this.sort = paramsList['productFlow_params'].sort;
                this.source_entity_account_rid = paramsList['productFlow_params'].source_entity_account_rid;
                this.source_product_code = paramsList['productFlow_params'].source_product_code;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
                if (this.postList.params.product_rid) {
                    this.product_rid = this.postList.params.product_rid;
                }
                this.getList(0); //获取列表
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
             onReSize('product_source', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).product_source;
        },
        //账户名称框改变事件
        valueChange(value) {
            this.rulesDialogFormProduct.source_entity_account_rid = value;
        },
        //账户名称远程搜索方法
        remoteMethod(query) {
            if (query !== '') {
                this.parentLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchAccounts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            setTimeout(() => {
                                this.parentLoading = false;
                                this.parentOptions = res.data;
                            }, 200);
                        } else {
                            this.parentOptions = [];
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.parentLoading = false;
                this.parentOptions = [];
            }
        },
        //优化点击新增框在弹出 红色表单验证
        handleClose() {
            this.dialogFormVisibleProduct = false;
            this.$refs['ruleFormProduct'].resetFields();
        },
        cancle() {
            this.dialogFormVisibleProduct = false;
            this.$refs['ruleFormProduct'].resetFields();
        },
        //新增
        addAcount() {
            this.dialogFormVisibleProduct = true;
            this.rulesDialogFormProduct = {
                source_entity_account_rid: '',
                source_product_code: '',
                source_product_name: '',
                source_product_specification: ''
            };
            this.titleProduct = '新增产品别名';
            this.parentOptions = [];
            this.parentLoading = false;
            this.dataType = 2;
        },
        //前往编辑页面
        editDetails(row) {
            this.dialogFormVisibleProduct = true;
            this.rulesDialogFormProduct = {
                rid: row.rid,
                source_entity_account_name: row.account.name,
                source_entity_account_rid: row.source_entity_account_rid,
                source_product_code: row.source_product_code,
                source_product_name: row.source_product_name,
                source_product_specification: row.source_product_specification
            };
            this.titleProduct = '修改产品别名';
            this.parentOptions = [];
            this.parentLoading = false;
            this.dataType = 1;
        },
        //删除产品别名行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .productSourceDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.getList(0);
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //提交新增/编辑修改
        submitDetailsData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    if (this.dataType == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交修改
        submitEditData() {
            let params = {
                rid: this.rulesDialogFormProduct.rid,
                product_rid: this.product_rid,
                source_entity_account_rid: this.rulesDialogFormProduct.source_entity_account_rid, // 账户下拉搜索，必填
                source_product_code: this.rulesDialogFormProduct.source_product_code, // 源产品编码，必填
                source_product_name: this.rulesDialogFormProduct.source_product_name, // 源产品名称，必填
                source_product_specification: this.rulesDialogFormProduct.source_product_specification // 源产品规格，必填
            };
            this.$api
                .productSourceUpdate(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.dialogFormVisibleProduct = false;
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.getList(0);
                    }
                })
                .catch((error) => {
                    this.dialogFormVisibleProduct = false;
                    this.btnLoading = false;
                    
                });
        },
        //提交新增
        submitAddData() {
            let params = {
                product_rid: this.product_rid,
                source_entity_account_rid: this.rulesDialogFormProduct.source_entity_account_rid, // 账户下拉搜索，必填
                source_product_code: this.rulesDialogFormProduct.source_product_code, // 源产品编码，必填
                source_product_name: this.rulesDialogFormProduct.source_product_name, // 源产品名称，必填
                source_product_specification: this.rulesDialogFormProduct.source_product_specification // 源产品规格，必填
            };
            this.$api
                .productSourceInsert(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.dialogFormVisibleProduct = false;
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.getList(0);
                    }
                })
                .catch((error) => {
                    this.dialogFormVisibleProduct = false;
                    this.btnLoading = false;
                    
                });
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['productFlow_params']) {
                    newParamsList['productFlow_params'].data_name = val.prop;
                    newParamsList['productFlow_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },

        //跳转详情
        handleClick(row, prop) {
            if (prop == 'account') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.account.rid
                    }
                });
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                product_rid: this.product_rid,
                source_entity_account_rid: this.source_entity_account_rid,
                source_product_code: this.source_product_code,
                is_export: type_data
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['productFlow_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .productSourceLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['productFlow_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .productSourceListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
            
                        this.down_loading = false;
                        
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['productFlow_params']) {
                    newParamsList['productFlow_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        product_rid: this.product_rid,
                        source_entity_account_rid: this.source_entity_account_rid,
                        source_product_code: this.source_product_code
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['productFlow_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['productFlow_params']) {
                    newParamsList['productFlow_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        product_rid: this.product_rid,
                        source_entity_account_rid: this.source_entity_account_rid,
                        source_product_code: this.source_product_code
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['productFlow_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.source_entity_account_rid = '';
            this.source_product_code = '';
            this.sort = '';
            this.data_name = '';
            this.parent_rid = '';
            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                source_entity_account_rid: '',
                source_product_code: '',
                parent_rid: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            newParamsList['productFlow_params'] = params;
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
.status_1 {
    color: green;
}
.status_2 {
    color: red;
}
</style>